/*
  MENU ITEMS
  path - url path in browser to match active class to highlight item
  route name is the vue router route name
  admin true - only user with is_admin=1 will show menu
*/
export default [
    {
        title: "Home",
        routeName: "home",
        icon: "lni lni-home",
        paths: ["/home"],
        active: false,
    },

    {
        title: "Orders",
        icon: "lni lni-add-files",
        paths: ["/orders"],
        active: false,
        permissions: ["Orders all enquire","Orders create","Orders process"],
        childVisible: false,
        children: [

            {
                title: "Enquiry",
                routeName: "orders",
                permissions: ["Orders all enquire"],
            },
            {
                title: "Create",
                routeName: "orders-create",
                permissions: ["Orders create"],
            },
            {
                title: "My Orders",
                routeName: "orders-rep-orders",
                permissions: ["Orders create"],
            },

            {
                title: "Process",
                routeName: "orders-process",
                permissions: ["Orders process"],
            },
        ],
    },

    {
        title: "Quote & Pricelist",
        icon: "lni lni-briefcase",
        paths: ["/quotations"],
        active: false,
        permissions: ["Quotations all enquire","Quotations create"],
        childVisible: false,
        children: [

            {
                title: "Enquiry",
                routeName: "quotations",
                permissions: ["Quotations all enquire"],
            },
           
            {
                title: "My Quotations",
                routeName: "quotations-rep-quotations",
                permissions: ["Quotations create"],
            },          

            {
                title: "Quotation Create",
                routeName: "quotations-create",
                permissions: ["Quotations create"],
            },
            {
                title: "Pricelist Create",
                routeName: "pricelist-create",
                permissions: ["Quotations create"],
            },
        ],
    },


    {
        title: "My Customers",
        routeName: "customers-balances",
        icon: "lni lni-invest-monitor",
        permissions: ["Orders create"],
        paths: ["/customers-balances"],
        active: false,
    },


    {
        title: "Products",
        icon: "lni lni-package",
        paths: ["/products", "/product-groups", "/brands", "/suppliers"],
        active: false,
        permissions: ["Manage products","Manage pricing"],
        childVisible: false,
        children: [


            {
                title: "Products",
                routeName: "products",
                permissions: [],
            },
            {
                title: "Pricing",
                routeName: "products-pricing",
                permissions: ["Manage pricing"],
            },
            {
                title: "Product Groups",
                routeName: "product-groups",
                permissions: ["Manage products"],
            },
            {
                title: "Brands",
                routeName: "brands",
                permissions: ["Manage products"],
            },
            {
                title: "Suppliers",
                routeName: "suppliers",
                permissions: ["Manage products"],
            },
        ],
    },

    {
        title: "Customers",
        routeName: "customers",
        icon: "lni lni-customer",
        paths: ["/customers"],
        permissions: ["Manage customers"],
        active: false,
    },


    {
        title: "Engagements",
        icon: "lni lni-handshake",
        paths: ["/stakeholders", "/engagements"],
        active: false,
        permissions: ["Manage stakeholders","Manage engagements"],
        childVisible: false,
        children: [

            {
                title: "Stakeholders",
                routeName: "stakeholders",
                permissions: ["Manage stakeholders"],
            },
            {
                title: "Engagements",
                routeName: "engagements",
                permissions: ["Manage engagements"],
            },

        ],
    },

    {
        title: "Catalogue",
        icon: "lni lni-list",
        paths: ["/catalogue"],
        active: false,
        permissions: ["Manage catalogue","Share catalogue"],
        childVisible: false,
        children: [
            {
                title: "Items",
                routeName: "catalogue-items",
                permissions: ["Manage catalogue"],
            },
            {
                title: "Share",
                routeName: "catalogue-share",
                permissions: ["Share catalogue"],
            },

        ],
    },


    {
        title: "Pallet Control",
        icon: "lni lni-agenda",
        paths: ["/pallet-movements", "/pallet-adjustments"],
        active: false,
        permissions: ["Pallet Movements","Pallet Adjustments"],
        childVisible: false,
        children: [
            {
                title: "Dashboard",
                routeName: "pallets-dashboard",
                permissions: ["Pallet Movements","Pallet Adjustments"],
            },

            {
                title: "Movements",
                routeName: "pallets-movements",
                permissions: ["Pallet Movements"],
            },
            {
                title: "Adjustments",
                routeName: "pallets-adjustments",
                permissions: ["Pallet Adjustments"],
            },

        ],
    },



    {
        title: "Clockings",
        routeName: "clockings",
        icon: "lni lni-alarm-clock",
        paths: ["/clockings"],
        permissions: ["Manage clockings"],
        active: false,
    },

    {
        title: "Reports",
        routeName: "reports",
        icon: "lni  lni-library",
        paths: ["/report"],
        permissions: ["View reports"],
        active: false,
    },


    {
        title: "System",
        icon: "lni lni-cogs",
        paths: ["/settings", "/companies", "parameters"],
        active: false,
        permissions: ["Manage settings", "Manage companies", "Manage schemes"],
        childVisible: false,
        children: [

            {
                title: "Reps",
                routeName: "reps",
                permissions: ["Manage reps"],
            },
            {
                title: "Clerks (Order & Pallets)",
                routeName: "clerks",
                permissions: ["Manage clerks"],
            },
            {
                title: "Branches",
                routeName: "branches",
                permissions: ["Manage branches"],
            },
            {
                title: "Parameters",
                routeName: "parameters",
                permissions: ["Manage companies"],
            },
            {
                title: "Company",
                routeName: "companies",
                permissions: ["Manage companies"],
            },


        ],
    },

    {
        title: "Users & Roles",
        icon: "lni lni-users",
        paths: ["/users", "/roles", "/user-logs"],
        active: false,
        permissions: ["Manage users", "Manage roles", "View user logs"],
        childVisible: false,
        children: [
            {
                title: "User Management",
                routeName: "users",
                permissions: ["Manage users"],
            },
            {
                title: "Roles Management",
                routeName: "roles",
                permissions: ["Manage roles"],
            },
            {
                title: "Logs",
                routeName: "user-logs",
                permissions: ["View user logs"],
            },
        ],
    },

    {
        title: "Admin",
        icon: "lni lni-warning",
        paths: ["/admin"],
        active: false,
        admin: true,
        childVisible: false,
        children: [
            {
                title: "Horizon Interface",
                routeName: "horizon",
            },
            {
                title: "Telescope Interface",
                routeName: "telescope",
            },
            {
                title: "User Logs",
                routeName: "user-logs",
                permissions: ["View user logs"],
            },
        ],
    },


];
